<template>
  <q-uploader
    ref="uploader"
    url="https://runpixie.com"
    :label="label"
    multiple
    color="white"
    flat
    :no-thumbnails="!filePickerThumbs"
    :accept="fileType === 'image' ? 'image/*' : 'video/*'"
    text-color="primary"
    class="file-picker file-wrapper"
    :filter="sortByName"
    @added="added"
    @removed="removed"
  />
</template>

<script>
import _ from "lodash";
export default {
  name: "FilePicker",
  props: {
    fileType: {
      type: String,
      required: true,
      validator: (value) => ["image", "video"].includes(value),
    },
    filePickerThumbs: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: "Select File",
    },
  },
  data() {
    return {
      selectedFiles: [],
    };
  },
  methods: {
    removed(file) {
      const key = file[0].__key;
      if (this.selectedFiles.length) {
        _.remove(this.selectedFiles, function (el) {
          return el.__key === key;
        });
        this.$emit("filesSelected", this.selectedFiles);
      }
    },
    added(files) {
      files.forEach((file) => {
        this.selectedFiles.push(file);
      });
      this.$emit("filesSelected", this.selectedFiles);
    },
    async addFromParent(selectedFilesCopy) {
      this.selectedFiles = [];
      await this.$refs.uploader.reset();
      await this.$refs.uploader.addFiles(selectedFilesCopy);
    },
    sortByName(files) {
      let arr = files.sort((a, b) => {
        return b.name.localeCompare(a.name, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      });

      return arr;
    },
  },
};
</script>

<style lang="scss" scoped>
.file-picker {
  width: 100%;
  max-width: 460px;
  height: auto;
  max-height: 350px;
}
</style>
